import React from 'react'
import classNames from 'classnames'

const XIcon = ({ iconClass, style, onClick, disabled }) => {
  return <i className={classNames(iconClass, style)} onClick={onClick} aria-disabled={disabled} />
}
export default XIcon
